import { render, staticRenderFns } from "./ConfigContainerTypeComponent.vue?vue&type=template&id=3b37359a&scoped=true"
import script from "./ConfigContainerTypeComponent.vue?vue&type=script&lang=ts"
export * from "./ConfigContainerTypeComponent.vue?vue&type=script&lang=ts"
import style0 from "./ConfigContainerTypeComponent.vue?vue&type=style&index=0&id=3b37359a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37359a",
  null
  
)

export default component.exports